import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { ClassroomInsUpdData } from "./ClassroomInsUpdData";
import { ClassroomInsUpdReview } from "./ClassroomInsUpdReview";
import { classroomInsert, classroomUpdate, classroomInsUpdSlice, selectClassroomInsUpd } from "../../../redux/classroom/classroomInsUpdSlice";
import ObjectInsUpd from "../../../features/base/page/ObjectInsUpd";
import { schoolClassroomsSlice } from "../../../redux/school/schoolClassroomsSlice";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import SchoolPageAvatar from "../../school/basics/SchoolPageAvatar";
import SchoolPageTitle from "../../school/basics/SchoolPageTitle";
import { classroomSlice, selectClassroom } from "../../../redux/classroom/classroomSlice";
import ClassroomPageTitle from "../basics/ClassroomPageTitle";
import ClassroomPageAvatar from "../basics/ClassroomPageAvatar";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { routeClassroom } from "../../../routes/classroom";
import { routeSchool } from "../../../routes/school";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { TopBar } from "../../../features/top/TopBar";

export function ClassroomInsUpd() {
  const dispatch = useAppDispatch();
  const school = useSelector(selectSchool);
  const classroomInsUpd = useSelector(selectClassroomInsUpd);
  const classroom = useSelector(selectClassroom);
  const {schoolId, classroomId} = useParams();

  console.log(`ClassroomInsUpd: ${schoolId}/${classroomId}`);
  if(!schoolId) {
    return <ElementMissingContext />;
  }

  const editing = classroomId !== undefined;
  const breadcrumbTitle = editing ? "Editar Sala de Aula" : "Nova Sala de Aula";

  if(editing) {
    if(classroomInsUpd.classroom.schoolId === "" && classroom.selected) {
      const changing = {
        ...classroom.selected
      };
      dispatch(classroomInsUpdSlice.actions.set(changing));
    }
  } else {
    if(classroomInsUpd.classroom.schoolId === "") {
      const changing = {
        ...classroomInsUpd.classroom
      };
      changing.schoolId = `${schoolId}`;
      dispatch(classroomInsUpdSlice.actions.set(changing));
    }
  }

  const breadcrumbs = [
    { 
      label: school.selected?.name ? school.selected?.name : "Escola", 
      href: routeSchool(schoolId, "classroom")
    },
    { label: breadcrumbTitle },
  ];

  const steps = [
    {
      name: "Dados da sala de aula",
      component: <ClassroomInsUpdData />,
      check: () => classroomInsUpd.classroom.name.length > 4,
    },
    {
      name: "Revisão",
      component: <ClassroomInsUpdReview />,
    }
  ];

  const title = (editing) ? <ClassroomPageTitle schoolId={schoolId} classroomId={classroomId} /> : <SchoolPageTitle schoolId={schoolId} />;
  const pageAvatar = (editing) ? <ClassroomPageAvatar /> : <SchoolPageAvatar />;

  const buildContent = () => 
    <ObjectInsUpd 
        name="sala de aula" 
        submit={() => 
          (editing)
          ? dispatch(classroomUpdate({classroomId: classroomId, classroom: classroomInsUpd.classroom}))
          : dispatch(classroomInsert({classroom: classroomInsUpd.classroom}))
        } 
        backTo={ (editing) ? routeClassroom(schoolId, classroomId, "main") :  routeSchool(schoolId, "classroom") }
        backCleanup={() => {
          dispatch(schoolClassroomsSlice.actions.clean());
          dispatch(classroomInsUpdSlice.actions.clean());
        }}
        state={classroomInsUpd.state} 
        steps={steps}
        edit={editing}
      />
    ;

  return <PageAuthenticatedLoading key="editUpdateClassroom"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
        states: editing ? [school.state, classroom.state] : [school.state], 
        content: buildContent,
        error: "Erro ao carregar sala de aula",
        retry: () => {
            dispatch(schoolSlice.actions.clean());
            dispatch(classroomSlice.actions.clean());
        }
        }}
    />;

}
